import React from "react";
import cn from "classnames";
import { noop } from "lib/utils";
import "styles/ui/select.scss";

const Select = ({ children, className, name, onChange = noop, options = [], value, ...props }) => {
  const onSelectChange = event => {
    onChange(event.target.value);
  };

  return (
    <select
      className={cn("otrl-jp__ui-select", className)}
      name={name}
      onChange={onSelectChange}
      value={value}
      {...props}
    >
      {options.map((option, index) => (
        <option key={index} value={option.value} disabled={!!option.disabled}>
          {option.label}
        </option>
      ))}
      {children}
    </select>
  );
};

export default Select;
